import { Text } from '@shared/components';

interface RandomizationLabelProps {
  mainLabel: string;
  commonLabel: string;
}

export default function RandomizationLabel(props: Readonly<RandomizationLabelProps>) {
  const { mainLabel, commonLabel } = props;

  return (
    <Text>
      <Text component='span' variant='body1Semibold'>
        {mainLabel}
      </Text>
      &nbsp;
      <Text component='span'>{commonLabel}</Text>
    </Text>
  );
}
